import { api } from "./api";
import { toast } from "sonner";
import { logError } from "./log";

// Blob download with an iframe-safe fallback: Chrome silently blocks
// same-context downloads inside embedded preview iframes, so target a new tab there.
export function downloadBlob(blob, fname, toastTitle = "Download ready") {
  const url = URL.createObjectURL(blob);
  const inIframe = window.self !== window.top;
  const trigger = () => {
    const a = document.createElement("a");
    a.href = url;
    a.download = fname;
    a.rel = "noopener";
    if (inIframe) a.target = "_blank";
    document.body.appendChild(a);
    a.click();
    a.remove();
  };
  trigger();
  toast.success(toastTitle, {
    description: "If the download didn't start, click Download.",
    action: { label: "Download", onClick: trigger },
    duration: 15000,
  });
  setTimeout(() => URL.revokeObjectURL(url), 120000);
}

export async function downloadResource(fileId, filename) {
  try {
    const { data } = await api.get(`/files/${fileId}`, { responseType: "blob" });
    downloadBlob(data, filename || "file");
  } catch (e) {
    logError("Download failed:", e);
    toast.error("Download failed");
  }
}
